import * as z from "zod/v4";

export const salesSlugContactFormSchema = z.object({
	name: z.string().min(1),
	email: z.email().transform((val) => val.toLowerCase()),
	phone: z.string().min(1),
	message: z.string().min(1),
	listingSlug: z.string(),
	listingAddress: z.string(),
	listingStatus: z.string(),
	listingPrice: z.string(),
	turnstileToken: z.string(),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type SalesSlugContactFormSchema = z.infer<typeof salesSlugContactFormSchema>;

export const salesSlugContactFormClientSchema = salesSlugContactFormSchema.pick({
	name: true,
	email: true,
	phone: true,
	message: true,
	turnstileToken: true
});
